import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { buildPersonalApiUrl } from '@zeusm/shared/core/helpers';
import { IS_POLLING_REQUEST } from '@zeusm/shared/core/init';
import { ProfileService } from '@zeusm/shared/session/profile';

import { ShellApi } from './shell-api.interface';
import { GetAccountsRes } from '../models';

@Injectable()
export class ShellApiService implements ShellApi {
  readonly #http = inject(HttpClient);
  readonly #profileService = inject(ProfileService);

  getAccounts(isPolling = false): Observable<GetAccountsRes> {
    const api = buildPersonalApiUrl('accounts/', {
      backoffice: this.#profileService.isActiveTreasurer(),
    });

    const context = new HttpContext().set(IS_POLLING_REQUEST, isPolling);

    return this.#http.get<GetAccountsRes>(api, { context });
  }
}
